module.exports = __webpack_public_path__ + "img/cartoon.076d12e1.webp";